import phonenumbers from 'google-libphonenumber';
/* global i18n: true */

global.i18n = global.i18n || {};
i18n.phonenumbers = phonenumbers;
const intl = window.hsIntl;
const messages = window.hsMessages;

/* eslint-disable guard-for-in */


// NOTE: IMPORTANT! If you remove or add a country to this list, make sure you
// also add its country code to
// HFUtils::$country_code_to_name_and_page_multiplier_map
i18n.phonenumbers.PhoneNumberUtil.countryNamesByShortCode = {
  AD: 'Andorra',
  // "AL": "Albania",
  AR: 'Argentina',
  AS: 'American Samoa',
  AT: 'Austria',
  AU: 'Australia',
  AX: 'Finland',
  // "BD": "Bangladesh",
  BE: 'Belgium',
  // "BG": "Bulgaria",
  // "BM": "Bermuda",
  BN: 'Brunei Darussalam',
  BR: 'Brazil',
  BS: 'Bahamas',
  CA: 'Canada',
  CH: 'Switzerland',
  // "CL": "Chile",
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DE: 'Germany',
  DK: 'Denmark',
  DO: 'Dominican Republic',
  ES: 'Spain',
  FI: 'Finland',
  FR: 'France',
  GB: 'United Kingdom',
  JE: 'United Kingdom - Jersey',
  IM: 'United Kingdom - Isle of Man',
  GG: 'United Kingdom - Guernsey',
  // "GE": "Georgia",
  // "GF": "French Guiana",
  GI: 'Gibraltar',
  GP: 'Guadeloupe',
  GR: 'Greece',
  GU: 'Guam',
  HK: 'Hong Kong',
  HR: 'Croatia',
  HU: 'Hungary',
  IE: 'Ireland',
  IL: 'Israel',
  IN: 'India',
  // "IQ": "Iraq",
  IS: 'Iceland',
  IT: 'Italy',
  JP: 'Japan',
  KH: 'Cambodia',
  KR: 'Republic of Korea',
  KY: 'Cayman Islands',
  LA: 'Laos',
  LU: 'Luxembourg',
  // "LV": "Latvia",
  // "MA": "Morocco",
  // "MC": "Monaco",
  MO: 'Macao',
  // "MP": "N. Mariana Islands",
  // "MQ": "Martinique",
  // "MT": "Malta",
  MY: 'Malaysia',
  NL: 'Netherlands',
  NO: 'Norway',
  NZ: 'New Zealand',
  PA: 'Panama',
  PE: 'Peru',
  // "PK": "Pakistan",
  PL: 'Poland',
  PR: 'Puerto Rico',
  PT: 'Portugal',
  PY: 'Paraguay',
  // "RE": "Reunion",
  RO: 'Romania',
  SE: 'Sweden',
  SG: 'Singapore',
  // "SI": "Slovenia",
  SK: 'Slovakia',
  // "SM": "San Marino",
  TH: 'Thailand',
  TR: 'Turkey',
  // "TT": "Trinidad and Tobago",
  TW: 'Taiwan',
  US: 'United States',
  UY: 'Uruguay',
  VI: 'Virgin Islands, U.S.',
  ZA: 'South Africa',
  AE: 'United Arab Emirates',
  SA: 'Saudi Arabia',
  QA: 'Qatar',
  EG: 'Egypt',
};

// Countries we prioritize the number matches for. Be sure to match the strings
// with the country names in countryNamesByShortCode
i18n.phonenumbers.PhoneNumberUtil.priorityCountries = ['United States', 'Canada', 'United Kingdom', 'Australia'];

i18n.phonenumbers.PhoneNumberUtil.prototype
  .getCountryNameByCountryShortCode = function getCountryNameByCountryShortCode(countryShortCode) {
    return i18n.phonenumbers.PhoneNumberUtil.countryNamesByShortCode[countryShortCode]
      ? i18n.phonenumbers.PhoneNumberUtil.countryNamesByShortCode[countryShortCode]
      : countryShortCode;
  };

/*
 Hungary area codes are 2 digits except Budapest, which is 1 digit resulting in 10 digits
 which gets overridden by an area code in the US, so this checks if the
 provided value starts with +36
 */
i18n.phonenumbers.PhoneNumberUtil.prototype.checkIsHungary = function checkIsHungary(number) {
  return number.match(/^\+36\s\d{1,2}\s\d{3}\s\d{3,4}$/);
};

const cleanNumber = (n) => String(n).replace(/\D/g, '').replace(/^0/, '');

i18n.phonenumbers.PhoneNumberUtil.prototype
  .getFormattedPhoneOptions = function getFormattedPhoneOptions(input, varphoneutils) {
    let results = [];
    const explicitInternationalCode = (input[0] === '+');

    // prevent email addresses like 555-555-5555@gmail.com to be formatted as phone numbers
    if (input.indexOf('@') >= 0) {
      return [];
    }

    // remove unnecessary characters
    let number = cleanNumber(input);
    const onumber = number;

    if (number.toString().length < 5) {
      return results;
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const region in i18n.phonenumbers.PhoneNumberUtil.countryNamesByShortCode) {
      let n;
      let valid;
      let exact = false;

      try {

        // parse number and check if it's valid
        n = varphoneutils.parseAndKeepRawInput(`+${number.toString()}`, region);
        valid = varphoneutils.isValidNumberForRegion(n, region);

        if (valid) {
          exact = true;
        }
      } catch (e) { /* do nothing */ }


      // if not valid try without leading +
      if (!valid && !explicitInternationalCode) {
        try {
          n = varphoneutils.parseAndKeepRawInput(number, region);
          valid = varphoneutils.isValidNumberForRegion(n, region);
        } catch (e) { /* do nothing */ }
      }

      if (!valid && region === 'IL' && number.match(/^972153/)) {
        // ISRAEL has a special fax number thing. If `+972 $number` is an israel
        // number `+972 153 $number` can fax that same number libphonenumber
        // doesn't validate that format so lets adjust
        number = number.replace(/^972153/, '972');

        try {
          n = varphoneutils.parseAndKeepRawInput(`+${number.toString()}`, region);
          valid = varphoneutils.isValidNumberForRegion(n, region);
        } catch (e) { /* do nothing */ }
      }

      // Budapest phone numbers are formatted to be 10 digits, re-format it so it
      // doesn't get validated as a US number
      if (!valid && region === 'HU' && number.match(/^1361\d{7}/)) {
        number = number.replace(/^1361/, '361');

        try {
          n = varphoneutils.parseAndKeepRawInput(`+${number.toString()}`, region);
          valid = varphoneutils.isValidNumberForRegion(n, region);
        } catch (e) { /* do nothing */ }
      }

      // push to results
      if (valid) {
        const countryCode = varphoneutils.getMetadataForRegion(region).getCountryCodeOrDefault();

        // this is necessary for certain short numbers. Example: 4281402
        n.setCountryCode(countryCode);

        let formattedNumber;
        try {
          // In the version of libphonenumber committed to this repo, this
          // sometimes throws. See +1 833-123-1234
          formattedNumber = varphoneutils.formatOutOfCountryCallingNumber(n);
        } catch (e) {
          continue; // eslint-disable-line no-continue
        }

        // see israel note above
        if (region === 'IL' && onumber.match(/^972153/)) {
          formattedNumber = formattedNumber.replace(/^\+972/, '+972 153');
        }

        if (region === 'HU' && onumber.match(/^1361\d{7}/)) {
          formattedNumber = formattedNumber.replace(/^\+1361/, '+36 1');
        }

        const result = {
          country: varphoneutils.getCountryNameByCountryShortCode(region),
          number: formattedNumber,
        };

        if (exact) {
          results.unshift(result);
        } else {
          results.push(result);
        }
      }
    }

    // Prepend priority countries when the user is NOT specifying a country code
    // explicity (using a plus)
    if (!explicitInternationalCode) {
      const priorityMatches = [];
      const { priorityCountries } = i18n.phonenumbers.PhoneNumberUtil;
      for (let i = 0; i < results.length; i++) {
        const currentResult = results[i];
        // Add priority countries if they're in the list
        if (priorityCountries.indexOf(currentResult.country) > -1) {
          priorityMatches.push(currentResult);
        }
      }

      priorityMatches.sort((a, b) => (
        priorityCountries.indexOf(a.country) - priorityCountries.indexOf(b.country)
      ));
      results = Array.prototype.concat(priorityMatches, results);
    }

    // Deduplicate array
    results = $.grep(results, (v, k) => {
      // Filter if index != first match index
      return $.inArray(v, results) === k;
    });

    return results;
  };

/*
 @number - internationally formatted fax number (digit wise, eg: these are all
 the same: '1555-555-5555' '15555555555' '1 (555) 555-5555'
 */
i18n.phonenumbers.PhoneNumberUtil.prototype
  .formatInternationalFaxNumber = function formatInternationalFaxNumber(number, options) {

    // strip to digits
    const digits = number.replace(/\D/g, '');

    if (digits.toString().length < 5) {
      return number;
    }

    // loop through options looking for an exact match
    for (let i = 0; i < options.length; i++) {
      const n = options[i].number.replace(/\D/g, '');

      // if match, return
      if (n === digits) {
        // eslint-disable-next-line no-param-reassign
        number = options[i].number;
        break;
      }
    }

    // return originally passed number, no formatting option found
    return number;
  };

i18n.phonenumbers.PhoneNumberUtil.prototype
  .updateDestinationOptions = function updateDestinationOptions(el, destination, options) {


    // reset changed
    el.attr('changed', 'false');

    if (options.length >= 1) {
      el.val(options[0].number);
      destination.html(`<div class="destination_text">${options[0].country.toLowerCase()}</div>`).fadeIn();
    }

    if (options.length > 1) {
      destination.addClass('multiple_destinations');
      let destinationOptionsHtml = '';
      for (let i = 0; i < options.length; i++) {
        const destinationClass = `destination_option${i === 0 ? ' selected' : ''}`;

        if (i === 1) {
          // we keep the number and country the same as whatever is currently selected
          destinationOptionsHtml += `<div class="${destinationClass}"><a target="_blank" rel="noopener noreferrer" href="http://www.hellofax.com/info/internationalFaxPricing">${intl.formatMessage(messages.countriesSupported)}</a></div>`;
        }

        destinationOptionsHtml += `<div class="${destinationClass}" number="${options[i].number}" country="${options[i].country}">${options[i].number} - ${options[i].country.toLowerCase()}</div>`;
      }

      destination.append(destinationOptionsHtml);
    } else {
      destination.removeClass('multiple_destinations');
    }

    el.attr('changed', el.val());


  };
// to detect country code leading a fax number

i18n.phonenumbers.PhoneNumberUtil.prototype
  .calculateMultiplier = function calculateMultiplier(number, countryCodeToFaxPagesMultiplierMap) {
    const regExpString = Object.keys(countryCodeToFaxPagesMultiplierMap).join('|');
    const countryCodeRegex = new RegExp(regExpString);
    if (number.indexOf('@') > 0) {
      return 0;
    }

    const countryCode = number.toString().replace(/\D/g, '').match(countryCodeRegex);
    let multiplier = 1;

    if (
      countryCode
      && countryCode.length > 0
      && countryCodeToFaxPagesMultiplierMap[countryCode[0]]
    ) {
      multiplier = countryCodeToFaxPagesMultiplierMap[countryCode[0]];
    }
    return multiplier;
  };

i18n.phonenumbers.PhoneNumberUtil.prototype
  .hasMultiplier = function hasMultiplier(
    number, varphoneutils, countryCodeToFaxPagesMultiplierMap,
  ) {
    return (varphoneutils.calculateMultiplier(number, countryCodeToFaxPagesMultiplierMap) > 1);
  };
